import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-video-modal',
  templateUrl: './add-video-modal.component.html',
  styleUrls: ['./add-video-modal.component.scss']
})
export class AddVideoModalComponent implements OnInit {

  videoName!: string;
  videoCode!: string;
  platform = 'YOUTUBE';

  constructor(
    readonly activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
  }

  addVideo() {
    let video = {
      videoName : this.videoName,
      videoCode : this.videoCode,
      platform : this.platform,
    }

    this.activeModal.close(video);
  }

}
